import { useEvents } from '@/api/queries';
import { useAuthStore } from '@/store/authStore';
import { useUIStore } from '@/store/uiStore';
import { EventItem } from '@/components/journal/EventItem';
import { ArchiveOverlay } from '@/components/journal/ArchiveOverlay';
import { haptic } from '@/lib/telegram';

export function JournalScreen() {
  const userId = useAuthStore((s) => s.userId);
  const openModal = useUIStore((s) => s.openModal);
  const setArchivePage = useUIStore((s) => s.setArchivePage);
  const { data, isLoading } = useEvents(userId, 10);
  const events = data?.events ?? [];

  return (
    <div
      className="flex-1 overflow-y-auto"
      style={{
        paddingTop:
          'calc(max(env(safe-area-inset-top, 0px), var(--tg-content-safe-area-top, 0px), var(--tg-safe-area-top, 0px)) + 0.5rem)',
      }}
    >
      <div className="px-5 pt-2 pb-3 flex items-center justify-between">
        <h1 className="font-display text-2xl text-white">Журнал</h1>
        <button
          onClick={() => {
            haptic('light');
            setArchivePage(1);
            openModal('archive');
          }}
          className="w-12 h-12 rounded-full bg-white/10 hover:bg-white/15 transition flex items-center justify-center"
          aria-label="Архив"
        >
          <img
            src="/data/interface/archive.webp"
            alt="Архив"
            className="w-7 h-7 object-contain"
          />
        </button>
      </div>
      <div className="px-5 pb-6 flex flex-col gap-4">
        {isLoading && (
          <div className="text-white/40 text-center py-10">Загружаем…</div>
        )}
        {!isLoading && events.length === 0 && (
          <div className="text-white/40 text-center py-10 italic">
            Пока что приключений нет.
          </div>
        )}
        {events.map((e) => (
          <EventItem key={e.id} event={e} />
        ))}
      </div>
      <ArchiveOverlay />
    </div>
  );
}
